import styled from "styled-components";

import { Box } from "../../../../../../components/Layout";

export const Container = styled.div``;

/* Inside the page's Box: without the side margins of a second one */
export const ThumbnailBox = styled(Box)`
  padding-top: 0;
  margin-right: 0;
  margin-left: 0;
`;

/* A group of fields with a title like the labels of the fields (LabelText), all in the editor's font */
export const Field = styled.div`
  margin-bottom: 24px;
  font-family: "Inter", sans-serif;

  .caption {
    display: block;
    margin-bottom: 12px;
  }

  .hint {
    margin-top: 8px;
    color: var(--color-neutral-light);
    font-size: 12px;
    line-height: 16px;
  }
`;

/** Two fields side by side (the prices, the installments). */
export const Pair = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  align-items: end;

  /* side by side, the space under a field (only the last of a column has none) would put one lower */
  > * {
    margin-bottom: 0;
  }
`;

/** The choices of where the button goes, apart from the field that follows them. */
export const ButtonTypes = styled.div`
  margin-bottom: 1rem;
`;

/** Featuring the plan: what it does beside the switch that turns it on. */
export const FeaturedRow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  font-family: "Inter", sans-serif;

  .text {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    min-width: 0;
  }

  h6 {
    color: var(--color-neutral-white);
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.25rem;
  }

  .description {
    color: var(--color-neutral-150);
    font-size: 0.75rem;
    line-height: 1rem;
  }

  /* the label of the switch is sized by its absolutely positioned track: give it the track's box */
  > label {
    flex-shrink: 0;
    width: 40px;
    height: 24px;
  }
`;
